@if (isMockMode()) {
  @if (isMockDialogExpanded()) {
    <div
      class="fixed right-4 top-4 z-[100] max-h-[80vh] w-full max-w-md overflow-auto rounded-lg border border-neutral-200 bg-white p-4 shadow-lg"
      role="dialog"
      aria-label="Mock check input"
    >
      <div class="mb-2 flex items-center justify-between gap-2">
        <h2 class="text-sm font-semibold">Mock check (test mode)</h2>
        <button
          type="button"
          (click)="isMockDialogExpanded.set(false)"
          class="rounded p-1 text-neutral-500 transition hover:bg-neutral-100 hover:text-neutral-700"
          [attr.aria-label]="'Minimize mock panel'"
        >
          <i class="icon icon-chevron-down rotate-180 text-sm"></i>
        </button>
      </div>
      <p class="mb-3 text-xs text-neutral-600">
        Default mock check is loaded automatically. Paste DoodOpenCheck JSON below to override.
      </p>
      <textarea
        [value]="mockCheckJson()"
        (input)="mockCheckJson.set($any($event.target).value); onMockCheckInputChange()"
        class="mb-3 min-h-[150px] w-full rounded border border-neutral-300 p-2 font-mono text-xs"
        placeholder='{"id": "...", "outstanding_amount": 3200, "items": [...], ...}'
        aria-describedby="mock-check-error"
      ></textarea>
      @if (mockCheckParseError()) {
        <p
          id="mock-check-error"
          class="mb-2 text-xs text-red-600"
          role="alert"
        >
          {{ mockCheckParseError() }}
        </p>
      }
    </div>
  } @else {
    <button
      type="button"
      (click)="isMockDialogExpanded.set(true)"
      class="fixed right-4 top-4 z-[100] rounded-lg border border-neutral-200 bg-white px-3 py-2 text-xs font-medium shadow transition hover:bg-neutral-50"
      [attr.aria-label]="'Expand mock panel'"
    >
      Mock
      <i class="icon icon-chevron-down -rotate-90 ml-1 inline-block text-xs"></i>
    </button>
  }
}

@if (displayHeader) {
  <app-back-header-atom
    [icon]="displayHeaderBack ? 'arrow-left' : undefined"
    [text]="headerText ?? 'pay-at-table.header' | translate"
    (navigationClick)="goBack()"
  ></app-back-header-atom>
}
<div class="pb-page-bottom">
  <router-outlet></router-outlet>
</div>
@if (error) {
  <app-pat-base-modal>
    <p class="font-base text-error-600">
      {{ error }}
    </p>
  </app-pat-base-modal>
}
